export default __webpack_public_path__ + "static/media/element_spec_23.7e7f9237.jpg";